<script setup lang="ts">
import axios from "axios";
import {computed, ref} from "vue";
// import {ref} from "vue";

// const props = defineProps<{}>()
// const emit = defineEmits<{}>()

const response = ref<any>(null)

async function abort() {
  response.value = await axios.post('/dev/sandbox/abort/402')
}

</script>

<template>
  <div class="sandbox">
    <b-button @click="abort">abort (axios)</b-button>

    <hr>

    <pre>{{ response }}</pre>
  </div>
</template>

<style scoped lang="scss">

</style>
